import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import {
    DEVICES_URL,
    CMDB_DEVICES_URL,
    CMDB_DEVICES_ADVANCED_URL,
} from 'src/constants/urls'
import { newExtractAvZones } from 'src/store/modules/runbooks/utils/cmdbOperations'
import uniq from 'lodash/uniq'

const devices = createReducer(
    {
        byId: {},
        values: [],
        searchResults: [],
        loading: false,
        cmdbImportDevices: [],
    },
    {
        [actions.SEARCH_DEVICES]: (state) => ({
            ...state,
            searchResults: [],
            loading: true,
        }),
        [actions.SEARCH_DEVICES_SUCCESS]: (state, action) => {
            const { results, keys, virps } = action.payload.data
            const searchResults = results.map((device) => device.id)
            return {
                ...state,
                byId: {
                    ...results.reduce(
                        (agg, device) => ({
                            ...agg,
                            [device.id]: {
                                ...device,
                                avZones: Object.keys(
                                    newExtractAvZones(
                                        device.children,
                                        keys,
                                        virps
                                    )
                                ),
                            },
                        }),
                        state.byId
                    ),
                },
                values: uniq([...state.values, ...searchResults]),
                searchResults,
                loading: false,
            }
        },
        [actions.SEARCH_DEVICES_ERROR]: (state) => ({
            ...state,
            searchResults: [],
            loading: false,
        }),
        [actions.SEARCH_DEVICES_CLEAR]: (state) => ({
            ...state,
            searchResults: [],
            loading: false,
        }),
        [actions.SEARCH_DEVICES_ADVANCED_SUCCESS]: (state, action) => {
            const { results } = action.payload.data
            return {
                ...state,
                cmdbImportDevices: results.map((device) => device.id),
                byId: {
                    ...state.byId,
                    ...results.reduce(
                        (agg, device) => ({
                            ...agg,
                            [device.id]: device,
                        }),
                        state.byId
                    ),
                },
                loading: false,
            }
        },
        [actions.SEARCH_DEVICES_ADVANCED_ERROR]: (state) => ({
            ...state,
            cmdbImportDevices: [],
            loading: false,
        }),
        [actions.TOGGLE_DEVICE_IMPORT]: (state, action) => {
            const { ci } = action.payload
            const { byId } = state
            return {
                ...state,
                byId: {
                    ...byId,
                    [ci]: {
                        ...byId[ci],
                        selected: !byId[ci].selected,
                    },
                },
            }
        },
        [actions.TOGGLE_ALL_DEVICES_IMPORT]: (state, action) => {
            const { checked } = action.payload
            const { byId, cmdbImportDevices } = state
            for (let i = 0; i < cmdbImportDevices.length; i++) {
                byId[cmdbImportDevices[i]].selected = checked
            }

            return {
                ...state,
                byId: { ...byId },
            }
        },
    }
)

export const searchDevices = (name, customer_id, solution = false) => ({
    type: actions.API,
    method: 'get',
    payload: {
        url: `${DEVICES_URL}${name && name + '/'}?${
            solution ? 'solution=true' : ''
        }${customer_id ? '&customer_id=' + customer_id : ''}`,
        start: () => ({ type: actions.SEARCH_DEVICES }),
        success: (payload) => ({
            type: actions.SEARCH_DEVICES_SUCCESS,
            payload,
        }),
        error: (error) => ({
            type: actions.SEARCH_DEVICES_ERROR,
            name: error.name,
            message: error.message,
        }),
    },
    debounce: {
        key: 'searchDevices',
        wait: 500,
    },
})

// TODO Store these in a separate reducer key since they
//  may not be in the db yet
export const searchCmdbDevices = (name) => ({
    type: actions.API,
    method: 'get',
    payload: {
        url: `${CMDB_DEVICES_URL}${name ? name + '/' : ''}`,
        start: () => ({ type: actions.SEARCH_DEVICES }),
        success: (payload) => ({
            type: actions.SEARCH_DEVICES_SUCCESS,
            payload,
        }),
        error: (error) => ({
            type: actions.SEARCH_DEVICES_ERROR,
            name: error.name,
            message: error.message,
        }),
    },
    debounce: {
        key: 'searchDevices',
        wait: 500,
    },
})

export const searchCmdbAdvanced = (filters) => ({
    type: actions.API,
    method: 'post',
    data: { filters },
    payload: {
        url: CMDB_DEVICES_ADVANCED_URL,
        start: () => ({ type: actions.SEARCH_DEVICES }),
        success: (payload) => ({
            type: actions.SEARCH_DEVICES_ADVANCED_SUCCESS,
            payload,
        }),
        error: (error) => ({
            type: actions.SEARCH_DEVICES_ADVANCED_ERROR,
            name: error.name,
            message: error.message,
        }),
    },
    debounce: {
        key: 'searchDevicesAdvanced',
        wait: 500,
    },
})

export const toggleDeviceForImport = (ci) => ({
    type: actions.TOGGLE_DEVICE_IMPORT,
    payload: { ci },
})

export const toggleAllDevicesForImport = (checked) => ({
    type: actions.TOGGLE_ALL_DEVICES_IMPORT,
    payload: {
        checked,
    },
})

export const clearSearchDevices = () => ({
    type: actions.SEARCH_DEVICES_CLEAR,
})

export const getDeviceById = (state, ci) => state.cmdb.devices.byId[ci]

export const getDeviceResults = (state) =>
    state.cmdb.devices.searchResults.map((id) => state.cmdb.devices.byId[id])

export const getImportedDevices = (state) =>
    state.cmdb.devices.cmdbImportDevices.map(
        (id) => state.cmdb.devices.byId[id]
    )

export const getDevicesForImport = (state) =>
    getImportedDevices(state).filter((device) => device.selected)

export default devices
